module.exports = __webpack_public_path__ + "img/Lifestyle_H_RGB_Global_2022_RestaurantAwards_PokePrep.ac8281d1.png";